import React from "react";
import { CurriculumBuilder } from "./ResourceHub";
import { useT } from "../context/LanguageContext";
import { BookOpen } from "lucide-react";

/**
 * Standalone "My Curriculum" page for teachers — pulled out of the Resource Hub
 * tabs and surfaced as its own drawer entry per user request.
 */
export default function TeacherCurriculumPage() {
  const t = useT();
  return (
    <div className="space-y-6" data-testid="teacher-curriculum-page">
      <div>
        <h1 className="font-display text-4xl font-bold flex items-center gap-3">
          <BookOpen className="w-8 h-8" /> {t("My Curriculum")}
        </h1>
        <p style={{ color: "var(--app-text-muted)" }}>
          {t("Plan your weekly focus points. Students see their progress on the Curriculum tab in their dashboard.")}
        </p>
      </div>
      <CurriculumBuilder />
    </div>
  );
}
